import graphql__2b61b56e49f5ca63f39a from "./__generated__/VoteButtons_votable.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { isUnauthorized } from "../Utils/authorizations";
import UpVoteButton from "./UpVoteButton";
import DownVoteButton from "./DownVoteButton";

const VoteButtons = ({ size = "sm", ...props }) => {
  const votable = useFragment(VoteButtons_votable, props.votable);
  const { votesSubmissionAuthorized, votesDownAuthorized } = votable.authorizations;

  if (isUnauthorized(votesSubmissionAuthorized)) return null;

  const className = classNames(["vote-buttons", props.className]);

  return (
    <div className={className}>
      <UpVoteButton votable={votable} size={size} className="margin-bottom-xs" />

      {!isUnauthorized(votesDownAuthorized) && (
        <DownVoteButton votable={votable} size={size} />
      )}
    </div>
  );
};

const VoteButtons_votable = graphql__2b61b56e49f5ca63f39a;

export default VoteButtons;
